import { j as s, B as a } from "./chunks/baseIcon-BOu_HqxP.js";
const e = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#314351" d="M13.25 16C13.25 16.6904 12.6904 17.25 12 17.25C11.3096 17.25 10.75 16.6904 10.75 16C10.75 15.3096 11.3096 14.75 12 14.75C12.6904 14.75 13.25 15.3096 13.25 16Z"/><path fill="#314351" d="M11 7.75C11 7.19772 11.4477 6.75 12 6.75C12.5523 6.75 13 7.19772 13 7.75V11.75C13 12.3023 12.5523 12.75 12 12.75C11.4477 12.75 11 12.3023 11 11.75V7.75Z"/></svg>';
function l(t) {
  return /* @__PURE__ */ s.jsx(a, { svg: e, ...t });
}
l.displayName = "SpecialStatusAlert";
export {
  l as default
};
